import script from "./selectLocale.vue?vue&type=script&setup=true&lang=ts"
export * from "./selectLocale.vue?vue&type=script&setup=true&lang=ts"

import "./selectLocale.vue?vue&type=style&index=0&id=5ee7f6b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ee7f6b8"]])

export default __exports__